import React from 'react';

import { focusFirstInvalidFormElement } from 'utils/focusFirstInvalidElement';
import { useWillUnmountRef } from 'hooks/useWillUnmountRef';

type Props = {
  allowImplicitSubmit?: boolean;
  onSubmit(): void;
};

const submitInputStyle = { display: 'none' };

export const CustomFormComponent: React.FC<Props> = (props) => {
  const { onSubmit, allowImplicitSubmit = false, children } = props;

  const willUnmountRef = useWillUnmountRef();

  const submitedRef = React.useRef(false);

  const formNodeRef = React.useRef<HTMLFormElement>(null);

  React.useEffect(() => {
    if (
      submitedRef.current &&
      !willUnmountRef.current &&
      !!formNodeRef.current
    ) {
      const focused = focusFirstInvalidFormElement(formNodeRef.current);
      submitedRef.current = !focused;
    }
  });

  const handleSubmit = React.useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      if (onSubmit) {
        onSubmit();
      }
      submitedRef.current = true;
    },
    [onSubmit]
  );

  return (
    <form ref={formNodeRef} onSubmit={handleSubmit}>
      {/*
        Невидимый неактивный submit-инпут помогает предотвратить отправку по Enter'у,
        при этом все еще можно использовать собственную видимую submit-кнопку,
        которая будет кликабельна Enter'ом и при этом будет вызывать submit-событие.

        https://stackoverflow.com/a/51507806
      */}
      {!allowImplicitSubmit && (
        <input type="submit" disabled style={submitInputStyle} />
      )}
      {children}
    </form>
  );
};
